/**
 * Пользователь действительно "смотрит" текущее окно:
 * - вкладка видима;
 * - окно браузера в фокусе (не переключен на другую программу).
 */
export function isUserActivelyViewingCurrentTab(): boolean {
  if (typeof document === 'undefined') return true;
  const isVisible = document.visibilityState === 'visible';
  const hasWindowFocus = typeof document.hasFocus === 'function' ? document.hasFocus() : true;
  return isVisible && hasWindowFocus;
}
